var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"body-2 text--secondary",attrs:{"xs12":""}},[_c('v-chip',{attrs:{"color":"accent","text-color":"white","label":"","small":""}},[_vm._v("B")]),_vm._v(" Tagged as billed. "),_c('v-chip',{attrs:{"color":"info","text-color":"white","label":"","small":""}},[_vm._v("P")]),_vm._v(" Tagged as in payroll ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }